export const environment = {
  production: true,
  demoMode: false,
  apiUrl: '/aha/v1',
};
